export enum VehiclePolicyUsage {
    Particular = "Particular",
}
